export default __webpack_public_path__ + "static/media/2.ab3fd371.png";